module.exports = __webpack_public_path__ + "img/dance-test-icon1.427b9de2.png";